import React from 'react'
import { Flex } from 'antd'
import SubmissionSearch from './SubmissionSearch'
import GroupsSort from './GroupsSort'
import CollapseAllGroupsButton from './CollapseAllGroupsButton'

const GroupsControls = () => (
    <div className='f-width'>
        <Flex gap={8} align='end' justify='space-between'>
            <SubmissionSearch />
            <Flex gap={8} align='end'>
                <CollapseAllGroupsButton />
                <GroupsSort />
            </Flex>
        </Flex>
    </div>
)

export default GroupsControls
